import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box } from 'rebass'
import IconCitygateChevron from '../../../vectors/IconCitygateChevron'
import media from '../../../utils/style'
import buildImageUrl from '../../../../lib/media-url-maker'

const Container = styled(Box)`
  width: 100%;
  max-width: 1210px;
  padding: 40px 20px 50px;
  margin-left: auto;
  margin-right: auto;

  ${media.MediumScreenUp`
    padding: 50px 32px 60px;
  `}

  ${media.LargeScreenUp`
    padding: 70px 32px 90px;
  `}
`

const HeroWrapper = styled.a`
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  text-decoration: none;
  border-radius: 20px;

  :hover,
  :focus,
  :active {
    .HeroCard__Image {
      img {
        transform: scale(1.05);
        transition: transform 0.2s ease-in-out;
      }
    }

    svg {
      transform: translateX(5px);
      transition: transform 0.2s ease-in-out;
    }
  }

  ${media.MediumScreenUp`
    flex-direction: column;
  `}
`

const HeroImage = styled(Box)`
  position: relative;
  width: 100%;
  padding-top: 30%; /* 10:3 aspect ratio (360/1200 = 0.3 = 30%) */
  overflow: hidden;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin: 0;
    transition: transform 0.1s ease-in-out;
  }
`

const HeroContent = styled(Box)`
  display: flex;
  flex: 1 1 auto;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
  padding: 25px 20px;
  background: #1f2c36;
  color: white;

  svg {
    color: white;
    opacity: 0.9;
    flex-shrink: 0;
    width: 23px;
    height: 27px;
    transition: transform 0.2s ease-in-out;
    background-blend-mode: overlay;
  }

  ${media.SmallishScreenUp`
    padding: 30px 20px 30px 25px;
    svg {
      flex-shrink: 0;
      width: 33px;
      height: 39px;
    }
  `}

  ${media.MediumScreenUp`
    align-items: flex-start;
  `}
`

const Title = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  padding-bottom: 24px;

  ${media.MediumScreenUp`
    padding-bottom: 32px;
  `}
`

const HeroTitle = styled.h3`
  font-size: 0.9375rem;
  font-weight: 700;
  color: inherit;
  margin: 0;
  color: ${(props) => props.textColor};

  ${media.SmallishScreenUp`
    font-size: 1rem;
  `}
`

const getImage = (item) =>
  item &&
  item.widgets &&
  item.widgets[0] &&
  item.widgets[0].crops &&
  item.widgets[0].crops[0] &&
  item.widgets[0].crops[0].src

const AutomotiveHeroCard = ({ title, description, heroImages, link }) => {
  return (
    <Container>
      <Title>{title}</Title>

      <HeroWrapper href={link} className="HeroCard">
        <HeroImage className="HeroCard__Image">
          <img
            src={buildImageUrl({
              width: 1200,
              resource: getImage(heroImages)
            })}
            alt={title}
          />
        </HeroImage>
        <HeroContent className="HeroCard__Content">
          <HeroTitle>{description}</HeroTitle>
          <IconCitygateChevron width={33} height={39} color="white" />
        </HeroContent>
      </HeroWrapper>
    </Container>
  )
}

AutomotiveHeroCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  heroImages: PropTypes.array.isRequired,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  link: PropTypes.string.isRequired
}

AutomotiveHeroCard.defaultProps = {
  backgroundColor: '#134083',
  textColor: 'white'
}

export default AutomotiveHeroCard
